// components/Spinner.js
// Shown by Layout.js while the next page loads. During the Halloween window (src/fx/season.js)
// it is a bouncing jack-o'-lantern with two bats circling it; otherwise a pink ring.
import styles from '../../styles/Spinner.module.css';
import { isHalloween } from '../fx/season';

const BAT = "M30 14 C24 6 14 4 3 8 C7 10 8 13 7 17 C10 14 14 15 15 19 C17 15 21 15 23 19 C24 15 27 14 30 17 Z M34 14 C40 6 50 4 61 8 C57 10 56 13 57 17 C54 14 50 15 49 19 C47 15 43 15 41 19 C40 15 37 14 34 17 Z M28 11 L28.6 5 L31 9.4 Z M36 11 L35.4 5 L33 9.4 Z M32 9 A5.2 7 0 1 0 32.01 9 Z";

const Spinner = () => {
  if (!isHalloween()) {
    return (
      <div className={styles.spinner} role="status" aria-label="Loading">
        <div className={styles.loader} />
      </div>
    );
  }

  return (
    <div className={styles.spinner} role="status" aria-label="Loading">
      <div className={styles.halloween}>
        <div className={styles.orbit}>
          <svg className={styles.bat} viewBox="0 0 64 32" aria-hidden="true"><path d={BAT} /></svg>
          <svg className={`${styles.bat} ${styles.bat2}`} viewBox="0 0 64 32" aria-hidden="true"><path d={BAT} /></svg>
        </div>
        <svg className={styles.pumpkin} viewBox="0 0 64 60" aria-hidden="true">
          <path d="M31 12 C30 7 32 3 36 2 C35 5 34 8 35 12 Z" fill="#3E9A4B" />
          <ellipse cx="20" cy="36" rx="14" ry="20" fill="#F2780C" />
          <ellipse cx="44" cy="36" rx="14" ry="20" fill="#F2780C" />
          <ellipse cx="32" cy="36" rx="14" ry="22" fill="#FF9426" />
          <g fill="#FFD23F">
            <path d="M18 30 L24 24 L28 32 Z M46 30 L40 24 L36 32 Z" />
            <path d="M16 40 Q32 54 48 40 L44 42 L41 39 L37 44 L33 40 L29 44 L25 39 L22 42 Z" />
          </g>
        </svg>
      </div>
    </div>
  );
};

export default Spinner;
